import { cn } from "@roman/shared/utils";
import { MinusIcon } from "lucide-react";
import type React from "react";

export const MinusButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (props) => {
  return (
    <button
      {...props}
      className={cn(
        "cursor-pointer outline-none border-none rounded-full bg-gray w-9 h-9 flex items-center justify-center",
        props.className,
      )}
      type="button"
    >
      <MinusIcon className="text-dark-gray w-5 h-5" />
    </button>
  );
};
